<template>
  <div class="row">
    <div class="col" v-if="docType !== 'ORIPOX'">
      <div class="row">
        <div v-if="showSiteFilter" class="col-2">
          <h6 class="heading-small text-muted">Site</h6>
          <div id="site-filter" class="input-group mb-3">
            <a-select 
              labelInValue
              :data-testid="`document-site-filter`"
              :value="filterSite"
              placeholder="Select a site"
              style="width: 100%"
              :filterOption="false"
              @dropdownVisibleChange="fetchSites"
              @change="selectSite"
              :notFoundContent="fetching ? undefined : null"
              >
              <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
              <a-select-option :id="`document-site-selection-${s.id}`" v-for="s in sites" :key="s.id.toString()">{{s.name}}</a-select-option>

            </a-select>
          </div>
        </div>

        <div class="col-3">
          <h6 class="heading-small text-muted">Document Date</h6>
            <div style="margin-bottom:0;">
              <a-range-picker :id="`document-date-filter`" suffixIcon=' ' @change="onDateFilter" v-model="filterText.defaultFilterDateValue" :placeholder="datePickerPlaceholder" />
            </div>
        </div>

        <div class="col-2">
          <h6 class="heading-small text-muted">Filter Date By</h6>
            <div style="margin-bottom:0;">
                  <a-select :id="`document-date-filter-by`" v-model="filterText.filterDateBy" style="width: 100%">
                    <a-select-option id="filter-by-document-date" value="document_date">
                      Document Date
                    </a-select-option>
                    <a-select-option id="filter-by-post-date" value="posted_at">
                      Post Date
                    </a-select-option>
                  </a-select>
            </div>
        </div>

        <div class="col-2">
          <h6 class="heading-small text-muted">Status</h6>
            <a-select :id="`document-status-filter`" placeholder="Status" style="width: 100%" v-model="filterText.filterStatus">
              <a-select-option :id="`filter-status-${option.value}`" v-for="option in filterStatusOptions" v-bind:key="option.key">{{option.value}}</a-select-option>
            </a-select>
        </div>

        <div v-if="showOrderStatus" class="col-2">
          <h6 class="heading-small text-muted">Order status</h6>
          <a-select :id="`document-order-status-filter`" v-if="docType == 'RELDDE'" placeholder="Order Status" style="width: 100%" v-model="filterText.filterOrderStatus">
            <a-select-option :id="`filter-order-status-${option.value}`" v-for="option in filterDeliveryOrderStatusOptions" v-bind:key="option.key">{{option.value}}</a-select-option>
          </a-select>
          <a-select :id="`document-order-status-filter`" v-else placeholder="Order Status" style="width: 100%" v-model="filterText.filterOrderStatus">
            <a-select-option :id="`filter-order-status-${option.value}`" v-for="option in filterOrderStatusOptions" v-bind:key="option.key">{{option.value}}</a-select-option>
          </a-select>
        </div>

        <div v-if="showOriginDocumentFilter" class="col-2">
          <h6 class="heading-small text-muted">Origin Document #</h6>
          <div class="input-group mb-3">
              <a-input :id="`document-origin-filter`" style="width: 100%" placeholder="Origin Document #"  v-model="filterText.filterDocumentCode"/>
          </div>
        </div>

        <div v-if="showDocumentNoFilter" class="col-2">
          <h6 class="heading-small text-muted">Document #</h6>
          <div class="input-group mb-3">
              <a-input :id="`document-document-no-filter`" style="width: 100%" placeholder="Document #"  v-model="filterText.filterDocumentNo"/>

          </div>
        </div>

        <div class="col-2 d-flex align-items-center filter_separator">
          <button id="document-apply-filter-button" type="button" class="btn btn-info btn-sm btn-block mt-3" @click='applyFilter'>Apply Filter</button>
        </div>

      </div>
      <div class="row mx-1" v-if="currentProfile !== 'product_price_worksheets'" >
        <a-collapse style="width: 100%; background: #FFFFFF;" @change="openDrawer">
            <a-collapse-panel id="document-advanced-filter-panel" header="Advanced Filter" >
              <div class="col">
                <!-- {{documentReference}} -->
                <!-- {{referenceFilters}} -->
                <h6 class="heading-small text-muted">Reference Filter</h6>

                <a-input-group compact>
                  <a-select id="document-reference-selection" style="width: 20%" v-model="selectedRefFilter">
                    <a-select-option v-for="option in documentReference" :key="option.name">{{option.name}}</a-select-option>
                  </a-select>
                  <a-input :id="`document-reference-input`" style="width: 80%" @keypress.enter="addReferenceFilter" v-model="searchText"/>
                  <!-- <a-button slot="addonAfter">+</a-button> -->
                </a-input-group>

                <div id="filterDiv">
                  <small>Reference Filters:</small>  &nbsp;
                  <div v-if="tags.length > 0">
                    <template>
                      <a-tag v-for="tag in tags" :key="tag" :afterClose="() => handleClose(tag)" color="blue" closable>  
                        {{tag}}
                      </a-tag>
                    </template>
                  </div>
                  <div v-else>
                    <a-tag> No reference filters applied</a-tag>
                  </div>
                  <br/>
                </div>
                <a-spin :spinning="loadUserInfos">
                <div class="row">
                  <div class="col">
                    <h6 class="heading-small text-muted">Supplier</h6>
                    <a-select :id="`document-supplier-filter`" style="width: 100%" v-model="filterText.filterSupplier" @dropdownVisibleChange="openSupplier">
                        <a-select-option v-for="option in filterSupplierOptions" v-bind:key="option.id">
                          {{option.name}}
                        </a-select-option>
                    </a-select>
                  </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">Created By</h6>
                     <a-select id="document-createdby-filter" style="width: 100%" v-model="filterText.filterCreatedBy" @dropdownVisibleChange="openUserList">
                      <a-select-option v-for="option in filterCreatedByOptions" v-bind:key="option.code">{{option.code}}</a-select-option>
                    </a-select>
                  </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">Posted By</h6>
                     <a-select id="document-postedby-filter" style="width: 100%" v-model="filterText.filterPostedBy" @dropdownVisibleChange="openUserList">
                      <a-select-option v-for="option in filterPostedByOptions" v-bind:key="option.code">{{option.code}}</a-select-option>
                    </a-select>
                  </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">Deliver To</h6>
                    <a-select id="document-deliverto-filter" style="width: 100%" v-model="filterText.filterDeliveryTo" @dropdownVisibleChange="openUserList">
                      <a-select-option v-for="option in filterDeliveryToOptions" v-bind:key="option.key">{{option.value}}</a-select-option>
                    </a-select>
                  </div>
                </div>
                 <div class="row mt-3">
                  <div class="col">
                    <h6 class="heading-small text-muted">Select Order</h6>
                    <a-select id="document-selectorder-filter" style="width: 100%" v-model="filterText.selectedOrder">
                      <a-select-option v-for="option in selectOrder" v-bind:key="option.key">{{option.value}}</a-select-option>
                    </a-select>
                  </div>
                  <div v-if='filterText.selectedOrder == 0'  class="col">
                    <h6 class="heading-small text-muted">Order #</h6>
                      <a-select id="document-orderno-filter" placeholder="Status" style="width: 100%" v-model="filterText.filterOrderNo">
                      <a-select-option v-for="option in filterOrderNoOptions" v-bind:key="option.key">{{option.value}}</a-select-option>
                    </a-select>
                  </div>
                  <div v-if='filterText.selectedOrder == 1'  class="col">
                    <h6 class="heading-small text-muted">Origin #</h6>
                      <a-select id="document-originno-filter" placeholder="Status" style="width: 100%" v-model="filterText.filterOriginNo">
                      <a-select-option v-for="option in filterOriginNoOptions" v-bind:key="option.key">{{option.value}}</a-select-option>
                    </a-select>
                  </div>
                  <div v-if='filterText.selectedOrder == 2'  class="col">
                    <h6 class="heading-small text-muted">Quantity</h6>
                      <a-select id="document-quantity-filter" placeholder="Status" style="width: 100%" v-model="filterText.filterQuantity">
                      <a-select-option v-for="option in filterQunatityOptions" v-bind:key="option.key">{{option.value}}</a-select-option>
                    </a-select>
                  </div>
                  <div class="col">
                    <h6 class="heading-small text-muted">Purpose</h6>
                    <a-select id="document-purpose-filter" style="width: 100%" v-model="filterText.filterPurpose" @dropdownVisibleChange="openPurpose">
                        <a-select-option v-for="option in filterPurposeOptions" v-bind:key="option.id">
                          {{option.name}}
                        </a-select-option>
                    </a-select>
                  </div>
                </div>
                </a-spin>
              </div>
            </a-collapse-panel>
        </a-collapse>
      </div>
    </div>

       <!-- /barter-11/bxi-backend/-/issues/2252 -->
      <!-- TESTING LAYOUT FOR ORIPOX FILTER -->
      <div class="col" v-else>
        <div class="row">
          <div v-if='showSiteFilter' class="col">
            <h6 class="heading-small text-muted">Site</h6>
            <div class="input-group mb-3">
              <a-select labelInValue :value="filterSite" placeholder="Select a site" style="width: 100%"
                :data-testid="`document-site-filter`" :filterOption="false" @dropdownVisibleChange="fetchSites" @change="selectSite"
                :notFoundContent="fetching ? undefined : null">
                <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                <a-select-option :data-testid="`document-site-selection-${s.id}`"   v-for="s in sites" :key="s.id.toString()">{{ s.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- /barter-11/bxi-backend/-/issues/2252 -->
          <!-- 1A make document date view wider -->
          <div class="col-3">
            <h6 class="heading-small text-muted">Document Date</h6>
            <div style="margin-bottom:0;">
              <a-range-picker :data-testid="`document-date-filter`" suffixIcon=' ' @change="onDateFilter" v-model="filterText.defaultFilterDateValue"
                :placeholder="datePickerPlaceholder" />
            </div>
          </div>

          <div class="col">
            <h6 class="heading-small text-muted">Filter Date By</h6>
            <div style="margin-bottom:0;">
              <a-select :data-testid="`document-date-filter-by`" v-model="filterText.filterDateBy" style="width: 100%">
                <a-select-option value="document_date">
                  Document Date
                </a-select-option>
                <a-select-option value="posted_at">
                  Post Date
                </a-select-option>
              </a-select>
            </div>
          </div>

          <div class="col-2">
            <h6 class="heading-small text-muted">Status</h6>
            <a-select :id="`document-status-filter`" placeholder="Status" style="width: 100%" v-model="filterText.filterStatus">
              <a-select-option v-for="option in filterStatusOptions" v-bind:key="option.key">{{ option.value }}
              </a-select-option>
            </a-select>
          </div>

          <div v-if='showOrderStatus' class="col-2">
            <h6 class="heading-small text-muted">Order status</h6>
            <a-select :id="`document-order-status-filter`" v-if="docType == 'RELDDE'" placeholder="Order Status" style="width: 100%"

              v-model="filterText.filterOrderStatus">
              <a-select-option v-for="option in filterDeliveryOrderStatusOptions" v-bind:key="option.key">{{ option.value
              }}
              </a-select-option>
            </a-select>
            <a-select :id="`document-order-status-filter`" v-else placeholder="Order Status" style="width: 100%" v-model="filterText.filterOrderStatus">
              <a-select-option v-for="option in filterOrderStatusOptions" v-bind:key="option.key">{{ option.value }}
              </a-select-option>
            </a-select>
          </div>

          <div v-if='showOriginDocumentFilter' class="col-3">
            <h6 class="heading-small text-muted">Origin Doc #</h6>
            <div class="input-group mb-3">
              <a-input :id="`document-origin-filter`" style="width: 100%" placeholder="Origin Document #" v-model="filterText.filterDocumentCode" />
            </div>
          </div>

          <div v-if='showDocumentNoFilter' class="col-3">
            <h6 class="heading-small text-muted">Document #</h6>
            <div class="input-group mb-3">
              <a-input :id="`document-no-filter`" style="width: 100%" placeholder="Document #" v-model="filterText.filterDocumentNo" />
            </div>
          </div>

          <div class="col-3 d-flex align-items-center">
            <button id="document-filter-apply-button" type="button" class="btn btn-info btn-sm btn-block mt-3" @click='applyFilter'>Apply Filter</button>
          </div>
        </div>

        <div class="row mx-1">
          <a-collapse style="width: 100%; background: #FFFFFF;" @change="openDrawer">
            <a-collapse-panel id="document-advanced-filter" header="Advanced Filter">
              <div class="col">
                <!-- {{documentReference}} -->
                <!-- {{referenceFilters}} -->
                <h6 class="heading-small text-muted">Reference Filter</h6>

                <a-input-group compact>
                  <a-select id="document-reference-selection" style="width: 20%" v-model="selectedRefFilter">
                    <a-select-option v-for="option in documentReference" :key="option.name">{{ option.name }}
                    </a-select-option>
                  </a-select>
                  <a-input id="document-reference-input" style="width: 80%" @keypress.enter="addReferenceFilter" v-model="searchText" />
                  <!-- <a-button slot="addonAfter">+</a-button> -->
                </a-input-group>

                <div id="filterDiv">
                  <small>Reference Filters:</small> &nbsp;
                  <div v-if="tags.length > 0">
                    <template>
                      <a-tag v-for="tag in tags" :key="tag" :afterClose="() => handleClose(tag)" color="blue" closable>
                        {{ tag }}
                      </a-tag>
                    </template>
                  </div>
                  <div v-else>
                    <a-tag> No reference filters applied</a-tag>
                  </div>
                  <br />
                </div>
                <a-spin :spinning="loadUserInfos">

                  <div class="row">
                    <!-- /barter-11/bxi-backend/-/issues/2252 -->
                    <!-- 1B Change Advance Filter UI arrangement -->
                    <div class="col-6">
                      <h6 class="heading-small text-muted">Supplier</h6>
                      <a-select id="document-supplier-filter" style="width: 100%" v-model="filterText.filterSupplier"
                        @dropdownVisibleChange="openSupplier">
                        <a-select-option v-for="option in filterSupplierOptions" v-bind:key="option.id">
                          {{ option.name }}
                        </a-select-option>
                      </a-select>
                    </div>

                    <div class="col-3">
                      <h6 class="heading-small text-muted">Created By</h6>
                      <a-select id="document-createdby-filter" style="width: 100%" v-model="filterText.filterCreatedBy"
                        @dropdownVisibleChange="openUserList">
                        <a-select-option v-for="option in filterCreatedByOptions" v-bind:key="option.code">{{ option.code
                        }}
                        </a-select-option>
                      </a-select>
                    </div>

                    <div class="col-3">
                      <h6 class="heading-small text-muted">Posted By</h6>
                      <a-select id="document-postedby-filter" style="width: 100%" v-model="filterText.filterPostedBy"
                        @dropdownVisibleChange="openUserList">
                        <a-select-option v-for="option in filterPostedByOptions" v-bind:key="option.code">{{ option.code
                        }}
                        </a-select-option>
                      </a-select>
                    </div>

                  </div>

                  <div class="row mt-3">
                    <div class="col-3">
                      <h6 class="heading-small text-muted">Deliver To</h6>
                      <a-select id="document-deliverto-filter" style="width: 100%" v-model="filterText.filterDeliveryTo"
                        @dropdownVisibleChange="openUserList">
                        <a-select-option v-for="option in filterDeliveryToOptions" v-bind:key="option.key">
                          {{ option.value }}</a-select-option>
                      </a-select>
                    </div>

                    <div class="col-3">
                      <h6 class="heading-small text-muted">Select Order</h6>
                      <a-select id="document-selectorder-filter" style="width: 100%" v-model="filterText.selectedOrder">
                        <a-select-option v-for="option in selectOrder" v-bind:key="option.key">{{ option.value }}
                        </a-select-option>
                      </a-select>
                    </div>

                    <div v-if='filterText.selectedOrder == 0' class="col-3">
                      <h6 class="heading-small text-muted">Order #</h6>
                      <a-select id="document-order-type" placeholder="Status" style="width: 100%" v-model="filterText.filterOrderNo">
                        <a-select-option v-for="option in filterOrderNoOptions" v-bind:key="option.key">{{ option.value }}
                        </a-select-option>
                      </a-select>
                    </div>

                    <div v-if='filterText.selectedOrder == 1' class="col-3">
                      <h6 class="heading-small text-muted">Origin #</h6>
                      <a-select placeholder="Status" style="width: 100%" v-model="filterText.filterOriginNo">
                        <a-select-option v-for="option in filterOriginNoOptions" v-bind:key="option.key">{{ option.value
                        }}
                        </a-select-option>
                      </a-select>
                    </div>

                    <div v-if='filterText.selectedOrder == 2' class="col-3">
                      <h6 class="heading-small text-muted">Quantity</h6>
                      <a-select placeholder="Status" style="width: 100%" v-model="filterText.filterQuantity">
                        <a-select-option v-for="option in filterQunatityOptions" v-bind:key="option.key">{{ option.value
                        }}
                        </a-select-option>
                      </a-select>
                    </div>
                  </div>
                </a-spin>
              </div>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </div>
  </div>
</template>

<script>
  import HTTPRequest from '../controllers/httpRequest.js'
  import { mapState } from 'vuex'
  import secureStorage from '../controllers/secureStorage.js'

  import moment from 'moment'

  export default {
    computed: {
      ...mapState(['currentProfile', 'endPoint', 'serverType']),
    },
    data: function(){
      return {
        filterText: {
                defaultFilterDateValue: [(secureStorage.getItem(`${secureStorage.getItem('documentTypeCode')}_documentSearchDateFrom`) == null || secureStorage.getItem(`${secureStorage.getItem('documentTypeCode')}_documentSearchDateFrom`) === 'Invalid date' ) ? moment(new Date()).format('YYYY-MM-DD') : moment(secureStorage.getItem(`${secureStorage.getItem('documentTypeCode')}_documentSearchDateFrom`)), 
                                        (secureStorage.getItem(`${secureStorage.getItem('documentTypeCode')}_documentSearchDateTo`) == null || secureStorage.getItem(`${secureStorage.getItem('documentTypeCode')}_documentSearchDateTo`) === 'Invalid date'  )? moment(new Date()).format('YYYY-MM-DD') : moment(secureStorage.getItem(`${secureStorage.getItem('documentTypeCode')}_documentSearchDateTo`))],
                filterStatus: '',
                filterDateBy: "document_date",
                filterOrderStatus: '',
                filterDocumentCode: '',
                filterDocumentNo:'',
                filterSupplier: '',
                filterPurpose:'',
                filterCreatedBy: '',
                filterPostedBy: '',
                filterDeliveryTo: '',
                filterQuantity: '',
                filterOrderNo: '',
                filterOriginNo: '',
                selectedOrder: 0
              },
        selectedRefFilter: null,
        tags: [],
        referenceFilters: {},
        filterCaption: "Choose reference",
        searchText: "",
        datePickerPlaceholder: ['Start', 'End'],
        documentReference: [],
        searchDateFrom: null,
        searchDateTo: null,
        loadUserInfos: false,
        firstRunLoadInfos: false,
        firstRunLoadUsers: false,
        firstRunLoadSuppliers: false,
        firstRunLoadPurpose:false,
        // filterStatus: '',
        // filterOrderStatus: '',
        showOrderStatus: false,
        showSiteFilter: false,
        showOriginDocumentFilter: false,
        showDocumentNoFilter:false,
        openSupplierList: false,
        // filterDocumentCode: '',
        // defaultFilterDateValue: [moment(new Date()).subtract('30', 'days'), moment(new Date())],
        sites: [],
        filterSite: {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")},
        fetching: false,
        docType : secureStorage.getItem('documentTypeCode'),
        filterStatusOptions: [
          {key: "", value: "All"},
          {key: "S", value: "Saved"},
          {key: "C", value: "Confirmed"},
          {key: "P", value: "Posted"},
          {key: "V", value: "Voided"}
        ],
        filterOrderStatusOptions: [
          {key: "", value: "All"},
          {key: "U", value: "Unfulfilled"},
          {key: "P", value: "Partially Delivered"},
          {key: "F", value: "Fulfilled"},
          {key: "D", value: "Done"},
        ],
        filterDeliveryOrderStatusOptions: [
          {key: "", value: "All"},
          {key: "O", value: "Open Delivery"},
          {key: "G", value: "Goods Issued"},
        ],
        filterSupplierOptions: [],
        filterPurposeOptions: [],
        filterCreatedByOptions: [],
        filterPostedByOptions: [],
        filterDeliveryToOptions: [],
        filterQunatityOptions: [
          {key: "ASC", value: "A ➤ Z"},
          {key: "DESC", value: "Z ➤ A"}
        ],
        filterOrderNoOptions: [
          {key: "ASC", value: "A ➤ Z"},
          {key: "DESC", value: "Z ➤ A"}
        ],
        filterOriginNoOptions: [
          {key: "ASC", value: "A ➤ Z"},
          {key: "DESC", value: "Z ➤ A"}
        ],
        selectOrder: [
          {key: 0, value: "Order #"},
          {key: 1, value: "Origin #"},
          {key: 2, value: "Quantity"},
        ],
        
      }
    },
    mounted: async function () {
        var currentDocumentTypeId = secureStorage.getItem('documentTypeId')
        var document_config = await HTTPRequest.getRequest(this.endPoint+'/document_types/get_document_type_settings?id='+ currentDocumentTypeId, null)
        if (document_config) {
          this.documentReference = document_config.document_type_settings.references;
          if (this.currentProfile != "product_price_worksheets") this.selectedRefFilter = this.documentReference[0].name
        }
        this.update_filter();
        if(secureStorage.getItem(`${secureStorage.getItem('documentTypeCode')}_documentSearchDateFrom`) != null){
          this.searchDateFrom = secureStorage.getItem(`${secureStorage.getItem('documentTypeCode')}_documentSearchDateFrom`)
        }
        if(secureStorage.getItem(`${secureStorage.getItem('documentTypeCode')}_documentSearchDateTp`) != null){
          this.searchDateFrom = secureStorage.getItem(`${secureStorage.getItem('documentTypeCode')}_documentSearchDateTp`)
        }
        this.applyFilter();

        // var get_data = await HTTPRequest.getRequest(this.endPoint+`/documents?document_type_id=${currentDocumentTypeId}&site_id=${this.filterSite.key}&searchDateFrom=${this.searchDateFrom}&searchDateTo=${this.searchDateTo}`)

        var userId = secureStorage.getItem("userId")
        var site_data = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_sites?user_id=' + userId, null)
        // console.log("get_data", get_data)
        // console.log("site_data", site_data)
        // console.log("site_data.length", site_data.length)
        // console.log("site_data data", site_data.data)

        if(site_data){
          for(let i = 0; i < site_data.length; i++){
            var source = site_data[i]; 
            if(!this.filterDeliveryToOptions.some(e => e.value == source.name)){
              let data3 = {
                key: source.id,
                value: source.name
              }
              this.filterDeliveryToOptions.push(data3)
            }
          }
          let dataFirst = {key: "", value: "All"}
          this.filterDeliveryToOptions.sort((a, b) => a.value.localeCompare(b.value))
          this.filterDeliveryToOptions.unshift(dataFirst)
        }
    },
    watch: {
      currentProfile: async function() {
        this.update_filter();
      },
      "filterText.selectedOrder": function(value) {
        if(value == 0){
          this.filterText.filterQuantity = ""
          this.filterText.filterOriginNo = ""
          this.filterText.filterOrderNo = "ASC"
        }else if(value == 1){
          this.filterText.filterOrderNo = ""
          this.filterText.filterOriginNo = "ASC"
          this.filterText.filterQuantity = ""
        }else{
          this.filterText.filterOrderNo = ""
          this.filterText.filterOriginNo = ""
          this.filterText.filterQuantity = "ASC"
        }
      }
    },
    methods: {
      doFilter: async function(){
        secureStorage.setItem(`${secureStorage.getItem('documentTypeCode')}_documentSearchDateFrom`, this.searchDateFrom)
        secureStorage.setItem(`${secureStorage.getItem('documentTypeCode')}_documentSearchDateTo`, this.searchDateTo)
      },
      handleClose(removedTag){
        var tagArray = removedTag.split(": ")
        var hashKey = tagArray[0]
        delete this.referenceFilters[hashKey]
        const tags = this.tags.filter(tag => tag !== removedTag)
        this.tags = tags
      },
      openSupplier: async function(){
        if(!this.firstRunLoadSuppliers){
          this.firstRunLoadSuppliers = true
          let suppliers_data = await HTTPRequest.getRequest(this.endPoint+'/suppliers/get_valid_suppliers', null)
          this.filterSupplierOptions = suppliers_data
          this.filterSupplierOptions.sort((a, b) => a.name.localeCompare(b.name))
          this.filterSupplierOptions.unshift({id: "", name: "All"});
        }
      },
      openPurpose:async function(){
        if(!this.firstRunLoadPurpose){
          this.firstRunLoadPurpose = true
          let purpose_data = await HTTPRequest.getRequest(this.endPoint+'/purposes/get_valid_purposes', null)
          this.filterPurposeOptions = purpose_data
          this.filterPurposeOptions.sort((a, b) => a.name.localeCompare(b.name))
          this.filterPurposeOptions.unshift({id: "", name: "All"});
        }
      },
      openUserList: async function(){
        if(!this.firstRunLoadUsers){
          this.firstRunLoadUsers = true
          let active_users = await HTTPRequest.getRequest(this.endPoint+'/users/get_active_users')
          let share = active_users.sort((a, b) => a.code - b.code)
          this.filterCreatedByOptions = share
          this.filterCreatedByOptions.unshift({id: "", code: "All"})
          this.filterPostedByOptions = share
        }
      },
      openDrawer: function(){
        if(!this.firstRunLoadInfos){
          this.firstRunLoadInfos = true
          this.loadUserInfos = true
          this.filterText.filterOrderNo = "ASC"
          this.filterSupplierOptions.push({id: "", name: "All"});
          this.filterCreatedByOptions.push({id: "", code: "All"})
          this.filterPostedByOptions.push({id: "", code: "All"})
          this.filterText.filterCreatedBy = 'All'
          this.filterText.filterPostedBy = 'All'
          this.loadUserInfos = false
        }
      },
      addReferenceFilter(value){
        if(_.isUndefined(this.referenceFilters[this.selectedRefFilter])){
          console.log(value)
          var index = this.documentReference.findIndex(p => p.name == this.selectedRefFilter)
          this.referenceFilters[this.selectedRefFilter] = {value: this.searchText, field: "reference_" + (index + 1).toString()}
          this.tags.push(this.selectedRefFilter + ": " + this.searchText)
          this.searchText = ""
        }else{
          alert("Filter exist.")
        }

      },
      update_filter(){
        var currentDocumentTypeCode = secureStorage.getItem('documentTypeCode')

        //Clear filter data
        this.filterSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
        this.defaultFilterDateValue = [moment(new Date()), moment(new Date())]
        this.searchDateFrom = moment(new Date()).format('YYYY-MM-DD')
        this.searchDateTo = moment(new Date()).format('YYYY-MM-DD')
        this.filterStatus =  ''
        this.filterOrderStatus = ''
        this.filterDocumentCode = ''
        this.filterDocumentNo = ''
        this.filterDateBy = ''

        let currentSiteSiteType = secureStorage.getItem("currentSiteSiteType")

        this.showSiteFilter = (this.serverType == 'ho' || currentDocumentTypeCode == 'ORITRQ' || currentDocumentTypeCode == 'OROTRQ') ? true : false;
        this.showSiteFilter = (currentSiteSiteType  == 'ho' || currentDocumentTypeCode == 'ORITRQ' || currentDocumentTypeCode == 'OROTRQ') ? true : false;
        this.showSiteFilter = (this.serverType == 'ho' || currentDocumentTypeCode == 'ORICSQ' || currentDocumentTypeCode == 'OROCSQ') ? true : false;
        this.showSiteFilter = (currentSiteSiteType  == 'ho' || currentDocumentTypeCode == 'ORICSQ' || currentDocumentTypeCode == 'OROCSQ') ? true : false;
        this.showSiteFilter = (currentSiteSiteType  == 'ho' || currentDocumentTypeCode == 'OTHPWS') ? true : false;
        // this.showSiteFilter = (this.currentProfile  == 'product_price_worksheets') ? true : false;

        switch(currentDocumentTypeCode) {
          case 'ORITRQ':
            this.showOrderStatus = true;
            break;
          case 'OROTRQ':
            this.showOrderStatus = true;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
            break;
          case 'RECTRX':
            this.showOrderStatus = false;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;

            break;
          case 'RELTRX':
            this.showOrderStatus = false;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
            break;
          case 'ORICSQ':
            this.showOrderStatus = true;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
            break;
          case 'OROCSQ':
            this.showOrderStatus = true;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
            break;
          case 'RECCSX':
            this.showOrderStatus = false;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
            break;
          case 'RELCSX':
            this.showOrderStatus = false;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
            break;

          case 'OTHPUR':
            this.showOrderStatus = false;
            break;
          case 'ORIPOX':
            this.showOrderStatus = true;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
            break;
          case 'ORIASN':
            this.showOrderStatus = true;
            this.showDocumentNoFilter = true;
            break;
          case 'RECDEL':
            this.showOrderStatus = false;
            this.showDocumentNoFilter = true;
            break;
          case 'RELRSR':
            this.showOrderStatus = false;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
            break;

          case 'RECADJ':
            this.showOrderStatus = false;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
            break;
          case 'RELADJ':
            this.showOrderStatus = false;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
            break;
          case 'OTHPCN':
            this.showOrderStatus = false;
            break;
          case 'ORISOX':
            this.showOrderStatus = true;
            break;
          case "OTHPWS":
            this.showOrderStatus = false;
          break;
          case 'OTHSIN':
            this.showDocumentNoFilter = true;
            break;
          case 'OTHSBI':
            this.showDocumentNoFilter = true;
            break;
          case 'RELDDE':
            this.showOrderStatus = true;
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
            break;
          default:
            this.showDocumentNoFilter = true;
            this.showOriginDocumentFilter = true;
          }
      },
      moment,
      onDateFilter(date, dateString) {
        this.searchDateFrom = dateString[0]
        this.searchDateTo = dateString[1]
      },
      applyFilter() {
        if(secureStorage.getItem('documentTypeCode') == "OTHPWS"){
          this.$emit('changeDocFilter', this.filterSite.key, this.searchDateFrom, this.searchDateTo, this.filterText.filterDateBy, 
          this.filterText.filterStatus, this.filterText.filterOrderStatus, this.filterText.filterDocumentCode, this.referenceFilters, this.filterText.filterSupplier, this.filterText.filterPostedBy, 
          this.filterText.filterDeliveryTo, this.filterText.filterQuantity, this.filterText.filterOrderNo, this.filterText.filterOriginNo, this.filterText.filterDocumentNo, this.filterText.filterPurpose)
        }else{
          var filterDocumentCode = (this.showOriginDocumentFilter) ? this.filterText.filterDocumentCode : ''
          this.$emit('changeFilter', this.filterSite.key, this.searchDateFrom, this.searchDateTo, this.filterText.filterDateBy,  this.filterText.filterStatus, 
          this.filterText.filterOrderStatus, filterDocumentCode, this.referenceFilters, this.filterText.filterSupplier, this.filterText.filterCreatedBy, this.filterText.filterPostedBy, 
          this.filterText.filterDeliveryTo, this.filterText.filterQuantity, this.filterText.filterOrderNo, this.filterText.filterOriginNo, this.filterText.filterDocumentNo, this.filterText.filterPurpose)
        }

      //Start
      //https://tools.iripple.com/barter-11/bxi-erk-backend/-/issues/68
      //[ERK] BXI to remember user last document filter

        this.doFilter();

      //https://tools.iripple.com/barter-11/bxi-erk-backend/-/issues/68
      //[ERK] BXI to remember user last document filter
      //End

      },
      async fetchSites() {
        this.fetching = true
        this.sites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_document_sites', null)
        this.sites.push({id: 0, code: 'All', name: 'All'})
        this.fetching = false
      },
      selectSite (filterSite) {
        Object.assign(this, {
          filterSite,
          sites: [],
          fetching: false,
        })
      }
    }
  }
</script>
<style scoped>
.filter_separator {
  height: 82px !important;
}
</style>
